import { Card } from "@/components/ui/card";

/**
 * Static instructional page: how a client downloads IRS transcripts (legacy
 * `Faqs::transcripts`). Content is fixed help copy, not DB-driven.
 */
export default function FaqTranscriptsPage() {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-3xl">
      <h2>Downloading IRS Transcripts</h2>
      <p>
        Taxpayers (or their authorized representative) can obtain account, wage &amp; income, and
        return transcripts directly from the IRS. Use the steps below to retrieve the records this
        firm needs to build your case.
      </p>
      <Card className="not-prose p-5">
        <ol className="ml-4 list-decimal space-y-3 text-sm">
          <li>
            Go to <strong>IRS.gov → Get Transcript Online</strong> and sign in (or create an
            ID.me account).
          </li>
          <li>Choose the reason for the request when prompted.</li>
          <li>
            Select the transcript type — <strong>Account Transcript</strong> and{" "}
            <strong>Wage &amp; Income Transcript</strong> are the most useful for resolution work.
          </li>
          <li>Select each tax year that applies to your case.</li>
          <li>Download the PDF for each year and upload it to your secure client portal.</li>
        </ol>
      </Card>
      <p className="text-muted-foreground text-sm">
        If you can’t verify your identity online, your practitioner can pull transcripts on your
        behalf once a valid Power of Attorney (Form 2848) is on file.
      </p>
    </div>
  );
}
